<template>
  <!--
    min-h-dvh: the inner wrapper below is `flex-1`, which has nothing to expand into unless
    this root has a definite height. Without it every h-full/flex-1 beneath collapses to
    content height, so full-page auth screens cannot place a CTA at the bottom.
  -->
  <div class="flex min-h-dvh flex-col pt-safe">
    <OrganismsNavPwaMobileNav v-if="pwaInstalled && showHeader" class="block md:hidden"/>
    <div
      class="flex flex-1 flex-col bg-white"
      :class="{ 'mt-[4rem]': pwaInstalled && showHeader }"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const showHeader = useState('pwa-auth-pages:showHeader', () => false)
const pwaInstalled = usePwaInstalled()
</script>

<style scoped>

</style>